import { NotesIcon } from '@/assets/icons/menu-icons/notes';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface NotesButtonProps {
  notesCount: number;
  openNotesPane: () => void;
}

const NotesButton = ({ notesCount, openNotesPane }: NotesButtonProps) => {
  return (
    <NotesWrapper onClick={openNotesPane}>
      <NotesCounterWrap>
        <NotesIcon width={24} height={24} fill={themeVar('font.action')} />
        <NotesCounter>{notesCount}</NotesCounter>
      </NotesCounterWrap>
      <NotesTitle>Notes</NotesTitle>
    </NotesWrapper>
  );
};

export default NotesButton;

const NotesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

const NotesCounterWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 3px;
`;

const NotesCounter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -5px;
  bottom: 0;
  right: 0;
  left: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  color: ${themeVar('font.action')};
`;

const NotesTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  color: ${themeVar('font.action')};
  margin-top: 3.5px;
`;
